import { c as _c } from "react/compiler-runtime";
import { CartItem } from './CartItem';
import { useCartConfirmDrawer } from './model/useCartConfirmDrawer';
export const CartItems = () => {
  const $ = _c(4);
  const items = useCartConfirmDrawer(_temp);
  let t0;
  if ($[0] !== items) {
    t0 = items.map(_temp2);
    $[0] = items;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = <ul className="basket-item-list">{t0}</ul>;
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
function _temp(state) {
  return state.items;
}
function _temp2(item) {
  return <CartItem {...item} key={item.sku} />;
}